import { uCheckLang } from 'ucheck/ucheck.lang';
import {
    AuthStatus,
    Direction,
    PortalPublish,
    Publish,
    Questioner,
    ReduxAction,
    ReportDetail,
    UserData,
    WorkSpace,
} from 'interface';

const APP_LANGUAGE = 'APP_LANGUAGE';
const setLanguage = (payload: typeof uCheckLang): ReduxAction<typeof uCheckLang> => ({
    type: APP_LANGUAGE,
    payload: payload,
});
export { APP_LANGUAGE, setLanguage };

const AUTH_STATUS = 'AUTH_STATUS';
const setAuthStatus = (payload: AuthStatus): ReduxAction<AuthStatus> => ({
    type: AUTH_STATUS,
    payload: payload,
});
export { AUTH_STATUS, setAuthStatus };

const APP_DIRECTION = 'APP_DIRECTION';
const setAppDirection = (payload: Direction): ReduxAction<Direction> => ({
    type: APP_DIRECTION,
    payload: payload,
});
export { APP_DIRECTION, setAppDirection };

const USER_DATA = 'USER_DATA';
const setUserData = (payload: UserData | null): ReduxAction<UserData | null> => ({ type: USER_DATA, payload: payload });
export { USER_DATA, setUserData };

const PUBLISH_DATA = 'PUBLISH_DATA';
const setPublishData = (payload: Publish | null): ReduxAction<Publish | null> => ({
    type: PUBLISH_DATA,
    payload: payload,
});
export { PUBLISH_DATA, setPublishData };

const WORKSPACE_DATA = 'WORKSPACE_DATA';
const setWorkspaceData = (payload: WorkSpace[] | null): ReduxAction<WorkSpace[] | null> => ({
    type: WORKSPACE_DATA,
    payload: payload,
});
export { WORKSPACE_DATA, setWorkspaceData };

const PUBLISHES_DATA = 'PUBLISHES_DATA';
const setPublishesData = (payload: Publish[] | null): ReduxAction<Publish[] | null> => ({
    type: PUBLISHES_DATA,
    payload: payload,
});
export { PUBLISHES_DATA, setPublishesData };

const CALENDERـLANG = 'CALENDERـLANG';
const setCalenderLanguage = <T>(payload: T): ReduxAction<T> => ({ type: CALENDERـLANG, payload: payload });
export { CALENDERـLANG, setCalenderLanguage };

const KIOSK_DATA = 'KIOSK_DATA';
const setKioskData = (payload: Publish | null): ReduxAction<Publish | null> => ({
    type: KIOSK_DATA,
    payload: payload,
});
export { KIOSK_DATA, setKioskData };

const PORTAL_DATA = 'PORTAL_DATA';
const setPortalPublishData = (payload: PortalPublish | null): ReduxAction<PortalPublish | null> => ({
    type: PORTAL_DATA,
    payload: payload,
});
export { PORTAL_DATA, setPortalPublishData };

const EXPIRE = 'EXPIRE';
const setExpire = (payload: boolean): ReduxAction<boolean> => ({
    type: EXPIRE,
    payload: payload,
});
export { EXPIRE, setExpire };

const ANSWER_DETIAL = 'ANSWER_DETIAL';
const setAnswerDetail = (payload: ReportDetail): ReduxAction<ReportDetail> => ({
    type: ANSWER_DETIAL,
    payload: payload,
});
export { ANSWER_DETIAL, setAnswerDetail };
